import { PublicNav, Footer } from "../components/PublicLayout";
import { Mail, AlertTriangle, CreditCard } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-background" data-testid="contact-page">
      <PublicNav />
      <div className="max-w-3xl mx-auto px-6 py-20">
        <p className="text-xs tracking-[0.25em] uppercase font-semibold text-muted-foreground mb-3">Contact</p>
        <h1 className="font-serif text-3xl md:text-4xl font-bold tracking-tight mb-6" data-testid="contact-title">Get in touch</h1>
        <p className="text-muted-foreground leading-relaxed mb-10">
          Questions about your subscription, account or the platform? Email us and we'll respond within 2 working days.
        </p>
        <div className="space-y-4">
          <div className="bg-card border border-border rounded-lg p-6 flex gap-4">
            <Mail className="w-5 h-5 text-primary shrink-0 mt-0.5" />
            <div>
              <h3 className="font-display font-semibold">General &amp; account support</h3>
              <p className="text-sm text-muted-foreground mt-1">pamindteam@gmail.com</p>
            </div>
          </div>
          <div className="bg-card border border-border rounded-lg p-6 flex gap-4">
            <AlertTriangle className="w-5 h-5 text-primary shrink-0 mt-0.5" />
            <div>
              <h3 className="font-display font-semibold">Question content issues</h3>
              <p className="text-sm text-muted-foreground mt-1">The fastest route is the "Report this question" button on any question — reports go straight to our clinical content team.</p>
            </div>
          </div>
          <div className="bg-card border border-border rounded-lg p-6 flex gap-4">
            <CreditCard className="w-5 h-5 text-primary shrink-0 mt-0.5" />
            <div>
              <h3 className="font-display font-semibold">Billing &amp; refunds</h3>
              <p className="text-sm text-muted-foreground mt-1">pamindteam@gmail.com — include your account email. Refund requests are reviewed within 14 days.</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
